import React from "react";

const CREATORS_APPLY_IFRAME_PAGE_LINK = "https://tours.lifeat.io/apply";
export default function CreatorsApplyPage() {
    return (
        <div className="info-page">
            <iframe src={CREATORS_APPLY_IFRAME_PAGE_LINK} frameBorder={0} />
        </div>
    );
}
